/// TaskPanel: Container for user task management.
/// Left pane shows the task list, right pane shows the routed form
/// for the selected task. Splits horizontally with a fixed-width task list.

import { TaskList } from "./tasks/TaskList";
import { TaskFormRouter } from "./tasks/TaskFormRouter";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function TaskPanel() {
  return (
    <div className="flex h-full">
      {/* Left: task list */}
      <div className="w-64 border-r border-zinc-700 overflow-y-auto shrink-0">
        <TaskList />
      </div>
      {/* Right: form router */}
      <div className="flex-1 overflow-y-auto min-w-0">
        <TaskFormRouter />
      </div>
    </div>
  );
}
